/**
 * The backend's status vocabulary, folded onto the three the UI draws. Shared
 * because both the list card and the detail hero read it off the same payloads
 * — one copy drifting means a competition badged wrong on one page and right
 * on the other.
 *
 * Anything unrecognised reads as live, which is the only status whose card
 * shows a running countdown.
 */
const STATUS_FROM_API = {
  active: 'live',
  live: 'live',
  ongoing: 'live',
  upcoming: 'upcoming',
  scheduled: 'upcoming',
  completed: 'ended',
  ended: 'ended',
  end: 'ended',
};

export const statusFromApi = (status) => STATUS_FROM_API[String(status).toLowerCase()] ?? 'live';

/**
 * A competition record's status as the UI draws it: the backend's word, except
 * that one whose `ends_at` has passed is ended whatever the record still says
 * (N64). The backend flips a competition to `completed` some time after it
 * closes — on 30 Sept the September competition (31 Aug – 29 Sep) was still
 * `active`, listed under Live with "Ends in 0d 0h 0m" and an open entry form.
 * The end instant is the competition's own, sent with an offset, so it needs
 * nothing from the viewer's device but "now".
 *
 * Only that one direction: an upcoming competition past its start is left
 * upcoming, since opening it is the backend's call, not the clock's.
 */
export const statusOf = (competition, now = Date.now()) => {
  const status = statusFromApi(competition?.status);
  const end = Date.parse(competition?.ends_at ?? '');
  return status === 'live' && Number.isFinite(end) && end <= now ? 'ended' : status;
};

/**
 * The competition name without the challenge suffix it still carries
 * ("September 2026 Competition - 100K Challenge") — `account_size_label` says
 * the same thing in its own field, which is where every screen draws the chip
 * or subtitle from. Records without a suffix pass through unchanged.
 */
export const titleOf = (competitionName) => String(competitionName ?? '').split(' - ')[0];
